import { render, staticRenderFns } from "./details-page.vue?vue&type=template&id=6ce3e88f"
import script from "./details-page.ts?vue&type=script&lang=ts&external"
export * from "./details-page.ts?vue&type=script&lang=ts&external"
import style0 from "./details-page.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ce3e88f')) {
      api.createRecord('6ce3e88f', component.options)
    } else {
      api.reload('6ce3e88f', component.options)
    }
    module.hot.accept("./details-page.vue?vue&type=template&id=6ce3e88f", function () {
      api.rerender('6ce3e88f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/details-page/details-page.vue"
export default component.exports